import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const heroImages = [
    '/hero/IMG_3533.jpg',
    '/hero/IMG_3542.jpg',
    '/hero/IMG_4137.jpg',
    '/hero/IMG_1990.jpg',
    '/hero/IMG_1985.jpg',
    '/hero/IMG_2011.jpg',
    '/hero/IMG_3532.jpg',
    '/hero/IMG_3049.jpg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <section className="relative py-12 md:py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Side - Text Content */}
          <div className="order-2 lg:order-1 lg:pr-8">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gray-900">
              I make working out <span className="text-primary-500">fun and effective</span>
            </h1>

            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Don't waste your time. Coach HT will get you to your health and fitness goals twice as fast using the PHYT method. A method focused on proper form and alignment.
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4 mb-12">
              <a 
                href="#packages" 
                className="w-full sm:w-auto bg-primary-500 text-white px-8 py-4 rounded-xl text-xl font-semibold hover:bg-primary-600 transition flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                onClick={(e) => {
                  e.preventDefault();
                  const packagesSection = document.getElementById('packages');
                  if (packagesSection) {
                    packagesSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Secure Your Spot
                <ArrowRight size={20} />
              </a>
            </div>
            
            {/* Stats Cards */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6">
              <div className="text-center p-4 sm:p-6 bg-white rounded-2xl border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="text-4xl sm:text-5xl mb-2">🎯</div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-primary-500 mb-2 sm:mb-3">8+</div>
                <div className="text-xs sm:text-sm font-bold text-gray-800 uppercase tracking-wide leading-tight">Years Experience</div>
              </div>
              <div className="text-center p-4 sm:p-6 bg-white rounded-2xl border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="text-4xl sm:text-5xl mb-2">💪</div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-primary-500 mb-2 sm:mb-3">500+</div>
                <div className="text-xs sm:text-sm font-bold text-gray-800 uppercase tracking-wide leading-tight">Clients Trained</div>
              </div>
              <div className="text-center p-4 sm:p-6 bg-white rounded-2xl border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <div className="text-4xl sm:text-5xl mb-2">🏆</div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-primary-500 mb-2 sm:mb-3">95%</div>
                <div className="text-xs sm:text-sm font-bold text-gray-800 uppercase tracking-wide leading-tight px-2">Success Rate</div>
              </div>
            </div>
          </div>

          {/* Right Side - Image Slideshow */}
          <div className="order-1 lg:order-2 relative flex items-center justify-center lg:pl-4 overflow-visible">
            <div className="relative w-full max-w-xl mx-auto lg:max-w-none aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl scale-[1.2] lg:ml-auto">
              {heroImages.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={image}
                    alt={`Hero image ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
              
              {/* Image indicators */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10">
                <div className="flex space-x-2 bg-black/30 backdrop-blur-sm px-3 py-2 rounded-full">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                        index === currentImageIndex 
                          ? 'bg-white scale-125' 
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;